import React from 'react';
import logo from '../../../assets/images/topaz-logo.svg';

export default function Logo() {
    return <img src={logo} alt='topaz-logo' />;
}
